<template>
  <div
    :class="['xb-cursor tx-js-cursor is-enabled', { 'is-active': isHovered }]"
  >
    <div class="xb-cursor-wrapper">
      <div class="xb-cursor--follower xb-js-follower"></div>
    </div>
  </div>
</template>
  
<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const isHovered = ref(false);

onMounted(() => {
  const e = document.querySelector(".tx-js-cursor");

  const handleMouseMove = (s) => {
    e.style.transform = `translate(${s.clientX}px, ${s.clientY}px)`;
  };

  window.addEventListener("mousemove", handleMouseMove);

  e.style.visibility = "visible";

  const anchors = document.getElementsByTagName("a");
  Array.from(anchors).forEach((item) => {
    item.addEventListener("mouseover", () => {
      isHovered.value = true;
    });
    item.addEventListener("mouseout", () => {
      isHovered.value = false;
    });
  });

  onUnmounted(() => {
    window.removeEventListener("mousemove", handleMouseMove);
    Array.from(anchors).forEach((item) => {
      item.removeEventListener("mouseover", () => {
        isHovered.value = true;
      });
      item.removeEventListener("mouseout", () => {
        isHovered.value = false;
      });
    });
  });
});
</script>
  

  